import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectGlobalDbnTaxonomyCategoriesListItems, selectGlobalDbnTaxonomyCategoriesQueryItems } from '../../../../redux/global-dbn-taxonomy-categories/selector';
import { globalDbnTaxonomyCategories } from '../../../../redux/global-dbn-taxonomy-categories/action';
import PageLoader from '../../../../components/PageLoader';
import GlobalDbnTaxonomyCategoriesComponent from '../components/global-dbn-taxonomy-category.component';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import { selectCurrent } from '../../../../redux/settings/selectors';
import UploadFiles from '../../../../models/UploadFile';
import { settings } from '../../../../redux/settings/actions';
import { deepCopy } from '../../../../common/services/common.service';

let currentChange: any = {}

const GlobalDbnTaxonomyCategory = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const queryGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesQueryItems)
  const listGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesListItems)
  const listGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [categoryImageIndex, setCategoryImageIndex] = useState<any>([])
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const [openFile, setOpenFile] = useState<any>([]);

  const [selectedCategory, setSelectedCategory] = useState<any>({
    Code: '',
    IsSubCategory: false,
    Name: '',
    ParentCategoryId: null,
    EntityAttributes: [],
    // FunctionAttributes: [],
    GlobalDBNDomainId: 0
  })
  const [entityAttributes, setEntityAttributes] = useState<any>([]);
  // const [functionAttributes, setFunctionAttributes] = useState<any>([]);

  const parentCategory = listGlobalDbnTaxonomyCategoryData?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubCategory === false
  )

  const fetchGlobalDbnTaxonomyCategoryById = async () => {
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'query' }))
    await dispatch(globalDbnTaxonomyCategories.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch-detail`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData:
      {
        Context: {},
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedCategory({ ...selectedCategory, [field]: event });
  }

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(() => {
    dispatch(globalDbnTaxonomyCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData: {
  "Context": {},
  "Records": [
    {}
  ],
  "Pagination": {
    "PageNumber":1,
    "PageSize": 100,
    "SortField": "GlobalDBNDomainId",
    "SortOrder": "desc"
  }
}
    })).then(() => {
      dispatch(globalDbnTaxonomyDomains.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
        entity: 'globalDbnTaxonomyDomains', jsonData:
        {
          "Context": {},
          "Records": [
            {
              "IsSubDomain": true
            }
          ],
          "Pagination": {
            // "PageNumber": pageData,
            // "PageSize": pageSize,
            "SortField": "GlobalDBNDomainId",
            "SortOrder": "desc",
          }
        }
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchGlobalDbnTaxonomyCategoryById()
      } else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    })
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedCategory(queryGlobalDbnTaxonomyCategoryData?.result?.items)
      const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryGlobalDbnTaxonomyCategoryData?.result?.items?.MediaMappings?.MediaFiles || mediaFiles });
      setMediaFiles(localSelectedMedia)

      // const selectedFunctionAttributes = queryItems?.result?.items?.FunctionAttributes.map((item:any) => {
      //   const attributes = {
      //     Id: item?.Id || 0,
      //     FunctionAttributeName: item?.FunctionAttributeName,
      //     FunctionAttributeValueDataTypeId:
      //       item?.FunctionAttributeValueDataTypeId,

      //     ValueItem1Type:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem1
      //         ?.Type || '',
      //     ValueItem1Value:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem1
      //         ?.Value || '',
      //     ValueItem1IsSelected:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem1
      //         ?.IsSelected || false,
      //     ValueItem2Type:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem2
      //         ?.Type || '',
      //     ValueItem2Value:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem2
      //         ?.Value || '',
      //     ValueItem2IsSelected:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem2
      //         ?.IsSelected || false,
      //     ValueItem3Type:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem3
      //         ?.Type || '',
      //     ValueItem3Value:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem3
      //         ?.Value || '',
      //     ValueItem3IsSelected:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem3
      //         ?.IsSelected || false,
      //     ValueItem4Type:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem4
      //         ?.Type || '',
      //     ValueItem4Value:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem4
      //         ?.Value || '',
      //     ValueItem4IsSelected:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem4
      //         ?.IsSelected || false,
      //     ValueItem5Type:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem5
      //         ?.Type || '',
      //     ValueItem5Value:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem5
      //         ?.Value || '',
      //     ValueItem5IsSelected:
      //       item?.FunctionAttributeDefaultValue?.MultiControlType?.ValueItem5
      //         ?.IsSelected || false,
      //     TextValue:
      //       item?.FunctionAttributeDefaultValue?.SingleControlType?.TextValue ||
      //       '',
      //     NumberValue:
      //       item?.FunctionAttributeDefaultValue?.SingleControlType?.NumberValue ||
      //       0,
      //     DateValue:
      //       item?.FunctionAttributeDefaultValue?.SingleControlType?.DateValue ||
      //       '',
      //     FileTypeId:
      //       item?.FunctionAttributeDefaultValue?.SingleControlType?.FileTypeId ||
      //       0,
      //     FileMappingUrl:
      //       item?.FunctionAttributeDefaultValue?.SingleControlType
      //         ?.FileMappingUrl || '',
      //     OwnerTypeId: item?.OwnerTypeId || 0,
      //     OwnerId: item?.OwnerId || 0,
      //   };

      //   return attributes;
      // });
      // setFunctionAttributes(selectedFunctionAttributes);
      const selectedEntityAttributes = queryGlobalDbnTaxonomyCategoryData?.result?.items?.EntityAttributes?.map((item: any) => {
        const attributes = {
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          ValueItem1Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Type || '',
          ValueItem1Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Value || '',
          ValueItem1IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1
              ?.IsSelected || false,
          ValueItem2Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Type || '',
          ValueItem2Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Value || '',
          ValueItem2IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2
              ?.IsSelected || false,
          ValueItem3Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Type || '',
          ValueItem3Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Value || '',
          ValueItem3IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3
              ?.IsSelected || false,
          ValueItem4Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Type || '',
          ValueItem4Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Value || '',
          ValueItem4IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4
              ?.IsSelected || false,
          ValueItem5Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Type || '',
          ValueItem5Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Value || '',
          ValueItem5IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5
              ?.IsSelected || false,
          TextValue:
            item?.EntityAttributeValue?.SingleControlType?.TextValue || '',
          NumberValue:
            item?.EntityAttributeValue?.SingleControlType?.NumberValue || 0,
          DateValue:
            item?.EntityAttributeValue?.SingleControlType?.DateValue || '',
          FileTypeId:
            item?.EntityAttributeValue?.SingleControlType?.FileTypeId || 0,
          FileMappingUrl:
            item?.EntityAttributeValue?.SingleControlType?.FileMappingUrl || '',
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: item?.OwnerId || 0,
        };
        return attributes;
      });
      setEntityAttributes(selectedEntityAttributes);
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const localMediaFiles = _.map(mediaFiles, (item) => {
      return {
        ...item,
        OwnerId: Number(parmas?.id) || 0,
        Name: selectedCategory?.Name,
        Description: selectedCategory?.Name,
        IsApproved: true,
      }
    })

    if (parmas?.id > 0) {
      // functionAttributes.splice(functionAttributes.length - 1, 1);
      // const selectedFunctionAttributes: any = functionAttributes.map((item:any) => {
      //   const attributes: any = {
      //     Id: item?.Id,
      //     FunctionAttributeName: item?.FunctionAttributeName,
      //     FunctionAttributeValueDataTypeId:
      //       item?.FunctionAttributeValueDataTypeId,
      //     FunctionAttributeDefaultValue: {
      //       MultiControlType: {
      //         ValueItem1: {
      //           Type: item?.ValueItem1Type || 'string',
      //           Value: item?.ValueItem1Value || 'string',
      //           IsSelected: item?.ValueItem1IsSelected || false,
      //         },
      //         ValueItem2: {
      //           Type: item?.ValueItem2Type || 'string',
      //           Value: item?.ValueItem2Value || 'string',
      //           IsSelected: item?.ValueItem2IsSelected || false,
      //         },
      //         ValueItem3: {
      //           Type: item?.ValueItem3Type || 'string',
      //           Value: item?.ValueItem2Value || 'string',
      //           IsSelected: item?.ValueItem3IsSelected || false,
      //         },
      //         ValueItem4: {
      //           Type: item?.ValueItem4Type || 'string',
      //           Value: item?.ValueItem4Value || 'string',
      //           IsSelected: item?.ValueItem4IsSelected || false,
      //         },
      //         ValueItem5: {
      //           Type: item?.ValueItem5Type || 'string',
      //           Value: item?.ValueItem5Value || 'string',
      //           IsSelected: item?.ValueItem5IsSelected || false,
      //         },
      //       },
      //       SingleControlType: {
      //         TextValue: item?.TextValue || 'string',
      //         NumberValue: item?.NumberValue || 0,
      //         DateValue: item?.DateValue || '2024-05-22T04:52:47.083',
      //         FileTypeId: item?.FileTypeId || 0,
      //         FileMappingUrl: item?.FileMappingUrl || 'string',
      //       },
      //     },
      //     OwnerTypeId: item?.OwnerTypeId || 0,
      //     OwnerId: Number(parmas?.id) || 0,
      //   };
      //   return attributes;
      // });
      entityAttributes?.splice(entityAttributes.length - 1, 1);
      const selectedEntityAttributes: any = entityAttributes?.map((item: any) => {
        const attributes: any = {
          Id: item?.Id,
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          EntityAttributeValue: {
            MultiControlType: {
              ValueItem1: {
                Type: item?.ValueItem1Type || 'string',
                Value: item?.ValueItem1Value || 'string',
                IsSelected: item?.ValueItem1IsSelected || false,
              },
              ValueItem2: {
                Type: item?.ValueItem2Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem2IsSelected || false,
              },
              ValueItem3: {
                Type: item?.ValueItem3Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem3IsSelected || false,
              },
              ValueItem4: {
                Type: item?.ValueItem4Type || 'string',
                Value: item?.ValueItem4Value || 'string',
                IsSelected: item?.ValueItem4IsSelected || false,
              },
              ValueItem5: {
                Type: item?.ValueItem5Type || 'string',
                Value: item?.ValueItem5Value || 'string',
                IsSelected: item?.ValueItem5IsSelected || false,
              },
            },
            SingleControlType: {
              TextValue: item?.TextValue || 'string',
              NumberValue: item?.NumberValue || 0,
              DateValue: item?.DateValue || '2024-05-22T04:52:47.083',
              FileTypeId: item?.FileTypeId || 0,
              FileMappingUrl: item?.FileMappingUrl || 'string',
            },
          },
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: Number(parmas?.id) || 0,
        };
        return attributes;
      });

      const categoryData = {
        Id: selectedCategory?.GlobalDBNCategoryId,
        Name: selectedCategory?.Name,
        IsSubCategory: selectedCategory?.IsSubCategory,
        ParentCategoryId: selectedCategory?.ParentCategoryId,
        Code: selectedCategory?.Code,
        GlobalDBNDomainId: selectedCategory?.GlobalDBNDomainId,
        MediaMappings: { MediaFiles: localMediaFiles, Templates: selectedCategory?.MediaMappings?.Templates || [] },
      }
      await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'update' }))
      await dispatch(globalDbnTaxonomyCategories.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories`,
        entity: 'globalDbnTaxonomyCategories',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      const categoryData = {
        Id: 0,
        Name: selectedCategory?.Name,
        IsSubCategory: selectedCategory?.IsSubCategory,
        ParentCategoryId: selectedCategory?.ParentCategoryId,
        Code: selectedCategory?.Code,
        GlobalDBNDomainId: selectedCategory?.GlobalDBNDomainId,
        MediaMappings: { MediaFiles: mediaFiles, Templates: [] },

      }
      await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'create' }))
      await dispatch(globalDbnTaxonomyCategories.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories`,
        entity: 'globalDbnTaxonomyCategories',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/dbn/categories')
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 175,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
    return localSelectedmedia
  }

  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }

  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setCategoryImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Category',
      type: fileType
    })
  }

  
  const handleSubmit = (data: any) => {
    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  useEffect(() => {
    if (currentChange.field === 'FileTypeId') {
      setCombinationInfo()
    }
  }, [mediaFiles]
  )

  return (
    <>
    {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {listGlobalDbnTaxonomyDomainData?.isLoading ||
        listGlobalDbnTaxonomyCategoryData?.isLoading ||
        queryGlobalDbnTaxonomyCategoryData?.isLoading ? <PageLoader /> :
        <GlobalDbnTaxonomyCategoriesComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedCategory={selectedCategory}
          parentCategory={parentCategory}
          back={back}
          handleFormSubmit={handleFormSubmit}
          entityAttributes={entityAttributes}
          setEntityAttributes={setEntityAttributes}
          id={parmas?.id}
          domains={listGlobalDbnTaxonomyDomainData?.result?.items}
          handleFormItemChange={handleFormItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
        //  functionAttributes={functionAttributes}
        //  setFunctionAttributes={setFunctionAttributes}
        />
      }
    </>
  )
}

export default GlobalDbnTaxonomyCategory;
